import { render, staticRenderFns } from "./questionnairesPoliciesTrainingTabComponent.vue?vue&type=template&id=06cd35d4"
import script from "./questionnairesPoliciesTrainingTabComponent.vue?vue&type=script&lang=js"
export * from "./questionnairesPoliciesTrainingTabComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports